module.exports = __webpack_public_path__ + "static/media/02.Vishwa Konkani Award- Bhaskar Kogga Kamath.0ea2c225.jpg";